(function () {
  var results = document.querySelector('[data-multi-results]');
  if (!results || results.dataset.multiReady) return;
  results.dataset.multiReady = 'true';

  var grid = results.querySelector('[data-collection-grid]');
  var inputs = Array.prototype.slice.call(document.querySelectorAll('input[data-pcf-handle]'));
  var pill = document.querySelector('[data-pcf-pill]');
  var clearBtn = document.querySelector('[data-pcf-clear]');
  if (!grid || (!inputs.length && !pill)) return;

  var perPage = parseInt(results.dataset.perPage, 10) || 12;
  var defaultHandle = results.dataset.defaultHandle || '';
  var allHandle = results.dataset.allHandle || 'all';
  var feedView = results.dataset.feedView || 'procapz-feed';
  var fixedTitle = results.dataset.fixedTitle || '';
  var anchor = document.querySelector('[id$="-grid-anchor"]');

  var countEl = document.querySelector('[data-multi-count]');
  var originalCount = countEl ? countEl.textContent : '';
  var originalGridHtml = grid.innerHTML;
  var originalPagination = results.querySelector('[data-pagination]');
  var originalPaginationHtml = originalPagination ? originalPagination.outerHTML : '';

  var requestId = 0;
  var items = [];
  var currentPage = 1;
  var paginationEl = null;

  function pillOn() {
    return Boolean(pill && pill.classList.contains('is-active'));
  }

  function setPill(on) {
    if (!pill) return;
    pill.classList.toggle('is-active', on);
    pill.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function checkedHandles() {
    var list = inputs.filter(function (i) { return i.checked && i.dataset.pcfHandle; }).map(function (i) { return i.dataset.pcfHandle; });
    if (pillOn() && pill.dataset.pcfHandle && list.indexOf(pill.dataset.pcfHandle) === -1) list.push(pill.dataset.pcfHandle);
    return list;
  }

  function handlesFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('colecoes')) return null;
    return (params.get('colecoes') || '').split(',').filter(Boolean);
  }

  function carriedQuery() {
    var keep = new URLSearchParams();
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'sort_by' || key === 'preview_theme_id') keep.append(key, value);
    });
    return keep.toString();
  }

  function fetchPage(handle, page) {
    var qs = carriedQuery();
    var url = '/collections/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(feedView) + '&page=' + page + (qs ? '&' + qs : '');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  }

  function cardsFrom(doc) {
    return Array.prototype.slice.call(doc.querySelectorAll('[data-product-card]'));
  }

  function fetchHandle(handle) {
    return fetchPage(handle, 1).then(function (doc) {
      var meta = doc.querySelector('[data-feed-meta]');
      var pages = meta ? parseInt(meta.dataset.pages, 10) || 1 : 1;
      var cards = cardsFrom(doc);
      if (pages <= 1) return cards;
      var rest = [];
      for (var p = 2; p <= pages; p++) rest.push(fetchPage(handle, p));
      return Promise.all(rest).then(function (docs) {
        docs.forEach(function (d) { cards = cards.concat(cardsFrom(d)); });
        return cards;
      });
    });
  }

  function setLoading(on) {
    grid.style.opacity = on ? '0.45' : '';
    grid.style.pointerEvents = on ? 'none' : '';
    grid.style.transition = 'opacity .2s ease';
  }

  function removePagination() {
    if (paginationEl && paginationEl.parentNode) paginationEl.parentNode.removeChild(paginationEl);
    paginationEl = null;
    var server = results.querySelector('[data-pagination]');
    if (server && server.parentNode) server.parentNode.removeChild(server);
  }

  function buildPagination(totalPages) {
    removePagination();
    if (totalPages <= 1) return;

    paginationEl = document.createElement('div');
    paginationEl.className = 'bss-collection-procapz__pagination';
    paginationEl.setAttribute('data-pagination', '');

    function arrow(label, symbol, target, disabled) {
      var el = document.createElement(disabled ? 'span' : 'a');
      el.className = 'bss-collection-procapz__page-arrow';
      el.setAttribute('aria-label', label);
      el.textContent = symbol;
      if (disabled) {
        el.setAttribute('aria-disabled', 'true');
      } else {
        el.href = '#';
        el.addEventListener('click', function (e) { e.preventDefault(); showPage(target, true); });
      }
      return el;
    }

    paginationEl.appendChild(arrow('Página anterior', '‹', currentPage - 1, currentPage <= 1));

    for (var p = 1; p <= totalPages; p++) {
      (function (page) {
        var el;
        if (page === currentPage) {
          el = document.createElement('span');
          el.className = 'bss-collection-procapz__page is-active';
        } else {
          el = document.createElement('a');
          el.className = 'bss-collection-procapz__page';
          el.href = '#';
          el.addEventListener('click', function (e) { e.preventDefault(); showPage(page, true); });
        }
        el.textContent = page;
        paginationEl.appendChild(el);
      })(p);
    }

    paginationEl.appendChild(arrow('Próxima página', '›', currentPage + 1, currentPage >= totalPages));
    grid.parentNode.insertBefore(paginationEl, grid.nextSibling);
  }

  function showPage(page, scroll) {
    var totalPages = Math.max(Math.ceil(items.length / perPage), 1);
    if (countEl) countEl.textContent = '(' + items.length + ')';
    currentPage = Math.min(Math.max(page, 1), totalPages);

    grid.innerHTML = '';
    if (!items.length) {
      var empty = document.createElement('p');
      empty.textContent = 'Nenhum produto encontrado.';
      empty.style.gridColumn = '1 / -1';
      empty.style.padding = '24px 0';
      grid.appendChild(empty);
    } else {
      items.slice((currentPage - 1) * perPage, currentPage * perPage).forEach(function (node) {
        grid.appendChild(document.importNode(node, true));
      });
    }

    buildPagination(totalPages);

    if (scroll && anchor) {
      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function restoreOriginal() {
    if (countEl) countEl.textContent = originalCount;
    grid.innerHTML = originalGridHtml;
    removePagination();
    if (originalPaginationHtml) {
      grid.insertAdjacentHTML('afterend', originalPaginationHtml);
    }
  }

  function updateUrl(selected) {
    var url = new URL(window.location.href);
    if (!selected.length) {
      url.searchParams.delete('colecoes');
    } else {
      url.searchParams.set('colecoes', selected.join(','));
    }
    url.searchParams.delete('page');
    window.history.replaceState({}, '', url.toString());
  }

  function apply() {
    var selected = checkedHandles();
    updateUrl(selected);

    var handles = selected.length ? selected : [allHandle];

    var id = ++requestId;
    setLoading(true);

    Promise.all(handles.map(fetchHandle))
      .then(function (lists) {
        if (id !== requestId) return;
        var seen = {};
        items = [];
        lists.forEach(function (list) {
          list.forEach(function (node) {
            /* Sem nenhuma categoria marcada: só produtos unitários (kits/bundles ficam de fora) */
            if (!selected.length && node.getAttribute('data-product-kit') === 'true') return;
            var key = node.getAttribute('data-product-id') || node.getAttribute('data-product-handle');
            if (seen[key]) return;
            seen[key] = true;
            items.push(node);
          });
        });
        setLoading(false);
        showPage(1, false);
      })
      .catch(function () {
        if (id !== requestId) return;
        setLoading(false);
      });
  }

  function applyFixedTitle() {
    if (!fixedTitle) return;
    var crumb = document.querySelector('.procapz-breadcrumbs__item--current span');
    if (crumb) crumb.textContent = fixedTitle;
  }

  inputs.forEach(function (input) {
    input.addEventListener('change', apply);
  });

  if (pill) {
    pill.addEventListener('click', function () {
      setPill(!pillOn());
      apply();
    });
  }

  function hasServerFilters() {
    var found = false;
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0) found = true;
    });
    return found;
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      inputs.forEach(function (input) { input.checked = false; });
      setPill(false);

      if (hasServerFilters() && defaultHandle) {
        var keep = new URLSearchParams();
        new URLSearchParams(window.location.search).forEach(function (value, key) {
          if (key === 'view' || key === 'preview_theme_id') keep.append(key, value);
        });
        var qs = keep.toString();
        window.location.href = '/collections/' + defaultHandle + (qs ? '?' + qs : '');
        return;
      }

      apply();
    });
  }

  applyFixedTitle();

  var fromUrl = handlesFromUrl();
  if (fromUrl) {
    inputs.forEach(function (input) {
      input.checked = fromUrl.indexOf(input.dataset.pcfHandle) !== -1;
    });
    if (pill) setPill(fromUrl.indexOf(pill.dataset.pcfHandle) !== -1);
  }
  setLoading(true);
  apply();
})();
